import { Children, ReactElement, cloneElement } from 'react';
import { Steps } from './ProgressSteps.styles';
import { Step, type StepProps } from './components';
import { type ProgressStepsProps, PROGRESS_STEP_CONST } from './ProgressSteps.d';

const ProgressSteps = ({ children, current, ...props }: ProgressStepsProps) => (
  <Steps.Component data-testid={PROGRESS_STEP_CONST.TEST_ID} {...props}>
    {Children.map(children, (child, index) => {
      const isActive = current - 1 === index;
      const isCompleted = current - 1 > index;
      const isLast = index === children.length - 1;
      const item = child as ReactElement<StepProps>;

      if (item.type !== Step) {
        throw new Error('Children must be of type Step');
      }

      return cloneElement(item, { active: isActive, completed: isCompleted, last: isLast });
    })}
  </Steps.Component>
);

export default ProgressSteps;
